import request from '@/util/request';
import qs from 'qs';


// 获取列表
export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 字典
export const getDictData = (params, options) =>
    request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));

//     获取当前登录人部门及子部门节点树/v4ward/dept/treeByIds
export const treeByIds = (params, options) =>
    request.get('/api/v4ward/dept/treeByIds', Object.assign({}, options, { params }));

// 月查询

export const monthPage = (params, options) =>
    request.get('/api/v4ward/energy/statistics/elect/dept/day/monthPage', Object.assign({}, options, { params }));
    // 月查询sum

export const monthSum = (params, options) =>
request.get('/api/v4ward/energy/statistics/elect/dept/day/monthSum', Object.assign({}, options, { params }));
    // 年查询
export const yearPage = (params, options) =>
    request.get('/api/v4ward/energy/statistics/elect/dept/month/yearPage', Object.assign({}, options, { params }));
    
// 年查询 SUM
export const yearSum = (params, options) =>
request.get('/api/v4ward/energy/statistics/elect/dept/month/yearSum', Object.assign({}, options, { params }));